import { Injector } from "@angular/core";
import { AutoUploadNode } from "../../AutoUploadNode";
import { AutoUploadEntityEnum } from "../../../AutoUploadEntityEnum";
import { ServiceEnum } from "../../../ServiceEnum";
import { BaseNode } from "../../BaseNode";
import { TreeNodeSubstancesList } from "../../Art57Node/ListEntity/TreeNodeSubstancesList";
import { DevelopmentSubstanceEntity } from "../../../Data/MedicinalProductData/DevelopmentSubstanceEntity";
import { TreeNodeSubstancePreviousEvCode } from "./TreeNodeSubstancePreviousEvCode";
import { TreeNodeMedicinalProductsAttachments } from "../ListEntity/TreeNodeMedicinalProductsAttachments";
import { TreeNodeMedicinalProductsSubstanceInternationalCode } from "../ListEntity/TreeNodeMedicinalProductsSubstanceInternationalCode";
import { TreeNodeMedicinalProductsSubstanceParentCode } from "../ListEntity/TreeNodeMedicinalProductsSubstanceParentCode";
import { SponsorAutoUploadEntity } from "./SponsorAutoUploadEntity";
import { TreeNodeMedicinalProductsSubstanceCodeName } from "../ListEntity/TreeNodeMedicinalProductsSubstancePreviousCodeName";
import { environment } from "../../../../../../environments/environment";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";

export class DevelopmentSubstanceAutoUploadEntity extends AutoUploadNode {
    useHist: boolean = false;
    constructor(injector: Injector, labelTemplate: string, parent: BaseNode, model: any, useHist: boolean, disableAutoUpload: boolean, cloningNode: boolean) {
        super(injector,
            labelTemplate,
            DevelopmentSubstanceEntity,
            useHist ? AutoUploadEntityEnum.developmentSubstanceHist : AutoUploadEntityEnum.developmentSubstance,
            ServiceEnum.MedicinalProducts,
            parent,
            model,
            TreeNodeSubstancesList,
            true,
            disableAutoUpload,
            cloningNode,
            { nodeTypeToCreateName: 'addDevelopmentSubstance' });
            this.labelNodeName = 'Development Substance';
            this.useHist = useHist;
    }

    override postLoadEntity(model: any): void {
        if (this.parent instanceof TreeNodeSubstancePreviousEvCode || this.cloningNode) {
            return;
        }

        if (model.sponsor) {
            this.children?.push(new SponsorAutoUploadEntity(this.ioc!, "Sponsor: " + model.sponsor.ev_Code + " - " + model.sponsor.name_Org, this, model.sponsor, this.useHist,true, false));
        }

        this.children?.push(new TreeNodeMedicinalProductsSubstanceCodeName(this.ioc!, this,false,  model.developmentsubstancenames?model.developmentsubstancenames.developmentsubstancename.filter((substancename:any)=>substancename.preferred!=1):[]));
// Not visible for Industry        this.children?.push(new TreeNodeMedicinalProductsSubstanceTranslation(this.ioc!, this, model.substancetranslations?model.substancetranslations.substancetranslation:[]));
// Not visible for Industry        this.children?.push(new TreeNodeMedicinalProductsSubstanceAlias(this.ioc!, this, model.substancealiases?model.substancealiases.substancealias:[]));
        this.children?.push(new TreeNodeMedicinalProductsSubstanceInternationalCode(this.ioc!, this, false, model.internationalcodesonly?model.internationalcodesonly.internationalcode:[]));
        this.children?.push(new TreeNodeMedicinalProductsSubstanceParentCode(this.ioc!, this, false, model.parentcodesonly?model.parentcodesonly.internationalcode:[]));
// Not visible for Industry        this.children?.push(new TreeNodeMedicinalProductsSubstancePreviousEvCode(this.ioc!, this, model.previousevcodes?model.previousevcodes.previousevcode:[]));
        this.children?.push(new TreeNodeMedicinalProductsAttachments(this.ioc!, 'Substance', this, false, model.substanceattachments?model.substanceattachments.substanceattachment:[]));

    }

    override cloneNode(newParent: BaseNode): BaseNode|undefined {
      let clonedNode: DevelopmentSubstanceAutoUploadEntity = new DevelopmentSubstanceAutoUploadEntity(this.ioc!, this.labelTemplate,newParent,this.datasource,this.useHist,false, true);      
//      clonedNode.disableAutoUpload = false;  
      clonedNode.loadEntity();
      clonedNode.isLoading = false;

      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
  
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

      if (!this.children || this.children.length===1) { // check if dummy node
  // not using disableAutoupload      clonedNode.postLoadEntity(this.datasource);
        clonedNode.cloningNode = false;
        return clonedNode; 
      }
  
      this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.cloningNode = false;
      return clonedNode;
    }

}